import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { useAppInteractionHandlers } from "../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useReport } from "../hooks/useReport.js";
import { ReportStateBadge } from "./ReportStateBadge.js";
import { UserNames } from "../../Users/shared/UserNames.js";
import "react";
import { Card, ColorSquare, Label, Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Reports/shared/ReportCard.tsx
var ReportCard = ({ onClick, reportId }) => {
	const appInteractionHandlers = useAppInteractionHandlers();
	const { data, loading } = useReport(reportId && { reportId });
	const isClickable = Boolean(!data?.report.deleted && (!!onClick || appInteractionHandlers?.onClickReport));
	if (!reportId) return null;
	if (!data?.report) return null;
	return /* @__PURE__ */ jsx(Card, {
		className: classnames("bg-surface-subtle relative overflow-hidden", { "cursor-pointer": isClickable }),
		onClick: isClickable ? () => {
			if (onClick) onClick(reportId);
			else if (appInteractionHandlers?.onClickReport) appInteractionHandlers.onClickReport(reportId);
		} : void 0,
		space: "xxs",
		padding: "xs",
		children: loading ? /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs("div", {
			className: "w-full",
			children: [/* @__PURE__ */ jsx(Skeleton.Text, {}), /* @__PURE__ */ jsx(Skeleton.Text, {})]
		}) }) : /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "gap-xs inline-flex w-full flex-wrap items-center justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "text-sm font-medium capitalize",
					children: [data.reportType.color && /* @__PURE__ */ jsx(ColorSquare, {
						marginRight: true,
						color: data.reportType.color
					}), data.report.title]
				}), /* @__PURE__ */ jsx(DateTime$1, { timestamp: data.report.date })]
			}), /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "gap-x-xxs flex truncate",
					children: [/* @__PURE__ */ jsx(Label, { children: "Authors" }), /* @__PURE__ */ jsx(UserNames, { users: data.report.authors })]
				}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ReportStateBadge, { state: data.report.state }) })]
			})]
		}), data.report.deleted && /* @__PURE__ */ jsx("div", {
			className: "z-sticky bg-critical/10 text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
			children: "DELETED"
		})] })
	});
};
//#endregion
export { ReportCard };

//# sourceMappingURL=ReportCard.js.map